import React, { useState, useReducer } from 'react';
import {
  Button,
  Snackbar,
  makeStyles,
  Theme,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import SendOutlined from '@material-ui/icons/SendOutlined';
import SuccessIcon from '@material-ui/icons/CheckCircle';
import { TestResults } from '../types';
import axios from 'axios';

const useStyles = makeStyles((theme: Theme) => ({
  snackBar: {
    background: theme.palette.success.main,
  },
  successIcon: {
    verticalAlign: 'middle',
    marginRight: '0.5em',
  },
  modal: {},
}));

interface SendResultsWidgetProps {
  results?: TestResults[];
}

//TODO: change copy data to send data via email

const initialState = {
  firstName: '',
  lastName: '',
  emailAddress: '',
};

function reducer(state: any, { field, value }: any) {
  return {
    ...state,
    [field]: value,
  };
}
/* const blocks = [
  {
    type: 'header',
    text: {
      type: 'plain_text',
      text: 'New Kixie Network Diag Submission :)',
      emoji: true,
    },
  },
  {
    type: 'divider',
  },
  {
    type: 'context',
    elements: [
      {
        type: 'image',
        image_url:
          'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcT8AwpV84dyKPJGjXFXMA7AJGsytf0mHRS3lQ&usqp=CAU',
        alt_text: 'call quality',
      },
      {
        type: 'mrkdwn',
        text: '*KIXIE* RTC Diag Submission via Jason',
      },
    ],
  },
  {
    type: 'context',
    elements: [
      {
        type: 'plain_text',
        text: `Customer Name: ${firstName} ${lastName}`,
        emoji: true,
      },
      {
        type: 'plain_text',
        text: `Email Address: ${emailAddress}`,
        emoji: true,
      },
    ],
  },
  {
    type: 'section',
    text: {
      type: 'mrkdwn',
      text: 'This is a section block with an overflow menu.',
    },
    accessory: {
      type: 'overflow',
      options: [
        {
          text: {
            type: 'plain_text',
            text: text,
            emoji: true,
          },
          value: 'value-0',
        },
      ],
    },
  },
];
 */
export default function SendResultsWidget({ results }: SendResultsWidgetProps) {
  const [sent, setSent] = useState(false);
  const [modal, toggleModal] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);

  const { firstName, lastName, emailAddress } = state;

  const classes = useStyles();

  if (!results) return null;

  const handleSubmit = async () => {
    const text = JSON.stringify(results, null, 2);
    axios
      .post(`https://hooks.slack.com/services/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`, JSON.stringify(text))
      .then((res) => console.log(res))
      .catch((err) => console.log(err))
      .finally(() => {
        setSent(true);
        toggleModal(false);
      });
  };

  const handleChange = (e: { target: { name: any; value: any } }) => {
    dispatch({
      field: e.target.name,
      value: e.target.value,
    });
  };
  const handleClick = () => {
    toggleModal(true);
  };
  return (
    <>
      <Snackbar
        ContentProps={{ className: classes.snackBar }}
        message={
          <span>
            <SuccessIcon className={classes.successIcon} />
            Results Sent to Kixie Customer Support
          </span>
        }
        open={sent}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        autoHideDuration={3000}
        onClose={() => setSent(false)}
      />
      <Button onClick={handleClick} variant="contained" color="secondary" disabled={sent}>
        <SendOutlined style={{ marginRight: '0.5em' }} />
        Share
      </Button>
      <Dialog open={modal}>
        <DialogTitle id="form-dialog-title">Send to Support@Kixie.com</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Fill in the following information to send your results to support@kixie.com
          </DialogContentText>
          <TextField
            autoFocus
            margin="normal"
            id="firstName"
            name="firstName"
            label="First Name"
            type="text"
            value={firstName}
            onChange={handleChange}
          ></TextField>
          <TextField
            autoFocus
            margin="normal"
            id="lastName"
            name="lastName"
            label="Last Name"
            type="text"
            value={lastName}
            onChange={handleChange}
          ></TextField>
          <TextField
            autoFocus
            margin="normal"
            id="emailAddress"
            name="emailAddress"
            label="Email Address"
            type="email"
            value={emailAddress}
            onChange={handleChange}
          ></TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
